export default function Logo({ size = 36, showText = true, linkTo = '/', textClassName = 'text-[#0F1A2E]' }) {
  return (
    <a href={linkTo} style={{ textDecoration: 'none' }} className="flex items-center gap-2 cursor-pointer">
      <div style={{ width: size, height: size, flexShrink: 0 }}>
        <svg viewBox="0 0 56 56" aria-hidden="true" style={{ width: '100%', height: '100%' }}>
          <defs>
            <linearGradient id="vault-body-grad" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor="#1B4FD8" />
              <stop offset="100%" stopColor="#0F1A2E" />
            </linearGradient>
            <style>{`
              .vault-dial {
                transform-origin: 38px 32px;
                animation: dialSpin 3s ease-in-out infinite;
              }
              .vault-halo {
                animation: haloPulse 2s ease-in-out infinite;
              }
              .vault-ok {
                animation: okFade 2s ease-in-out infinite;
              }
              @keyframes dialSpin {
                0%, 100% { transform: rotate(0deg); }
                30%       { transform: rotate(120deg); }
                60%       { transform: rotate(240deg); }
              }
              @keyframes haloPulse {
                0%, 100% { r: 3; opacity: 0.3; }
                50%      { r: 6; opacity: 0; }
              }
              @keyframes okFade {
                0%, 40%    { opacity: 1; }
                60%, 100%  { opacity: 0.6; }
              }
            `}</style>
          </defs>
          <rect x="8"  y="10" width="40" height="38" rx="3" fill="url(#vault-body-grad)" />
          <rect x="12" y="14" width="32" height="30" rx="2" fill="url(#vault-body-grad)" />
          <circle cx="38" cy="32" r="5" fill="none" stroke="#FFFFFF" strokeWidth="1.5" />
          <rect className="vault-dial" x="37" y="28" width="2" height="5" rx="1" fill="#00D4AA" />
          <rect x="16" y="26" width="4" height="12" rx="1" fill="#FFFFFF" opacity="0.4" />
          <circle className="vault-halo" cx="44" cy="20" r="3" fill="none" stroke="#00D4AA" strokeWidth="1.5" />
          <circle className="vault-ok"  cx="44" cy="20" r="3" fill="#00D4AA" />
          <rect x="12" y="48" width="4" height="4" fill="#0F1A2E" />
          <rect x="40" y="48" width="4" height="4" fill="#0F1A2E" />
        </svg>
      </div>
      {showText && (
        <span className={`font-black tracking-tight text-[17px] ${textClassName}`}>MyContrat</span>
      )}
    </a>
  );
}
